module.exports = __webpack_public_path__ + "img/Part1.780c31b.svg";